import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('a', {
    class: _vm.$style.Instruction,
    attrs: {
      "href": _setup.props.link
    }
  }, [_c('div', {
    class: _vm.$style.text
  }, [_vm._v("\n    " + _vm._s(_setup.props.text) + "\n  ")]), _vm._v(" "), _c(_setup.SIcon, {
    class: _vm.$style.icon,
    attrs: {
      "icon": "arrow-diagonal",
      "size": "24"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };